import { Box } from "@mui/material";

const Line = () => {
  return <Box sx={{ border: ".063rem solid #252835", marginBottom: "7rem" }} />;
};

export default Line;
